function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    this.headerInner = document.querySelector('.header');


    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
    if (this.headerInner.getAttribute('data-white') != 'true'){
      this.headerInner.classList.remove('header--white');
    }

  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    this.headerInner.classList.add('header--white');
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');

  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length) linkElements.forEach(button => {
          button.removeAttribute('tabindex');
        });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length) linkElements.forEach(button => {
          button.setAttribute('tabindex', '-1');
        });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    window.addEventListener('DOMContentLoaded', () => {
     this.updateOptions();
     this.updateMasterId();
     this.handleShippingDrawer();
   });
  }



  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.updateAvailabilityText();
    this.removeErrorMessage();
    this.handleShippingDrawer();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }
  handleShippingDrawer() {
    const availabilityText = document.querySelector('.main-product__availability-text');
    if (!availabilityText || !this.currentVariant) return;
  
    if (this.currentVariant.inventory_policy === 'continue' && this.currentVariant.inventory_quantity <= 0) {
      availabilityText.classList.remove('shipping-drawer__call');
      
      availabilityText.removeAttribute('role');
      availabilityText.removeAttribute('aria-haspopup');
      
      const newElement = availabilityText.cloneNode(true);
      availabilityText.parentNode.replaceChild(newElement, availabilityText);
    } else {
      availabilityText.classList.add('shipping-drawer__call');
      
      const shippingDrawer = document.querySelector('shipping-drawer');
      if (shippingDrawer) {
        shippingDrawer.setHeaderCartIconAccessibility();
      }
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }
  updateAvailabilityText() {
    const availabilityText = document.querySelector('.main-product__availability-text');
    if (!availabilityText || !this.currentVariant) return;
  
    const variant = this.currentVariant;
    const pickupAvailability = document.querySelector('pickup-availability');
    const variantPreorders = JSON.parse(pickupAvailability.dataset.variantPreorders || '{}');
    const preorderText = variantPreorders[variant.id];
  
    if (variant.inventory_management === 'shopify') {
      if (variant.inventory_quantity <= 0 && variant.inventory_policy === 'continue' && variant.available) {
        availabilityText.innerHTML = `${preorderText || window.variantStrings.preOrder}`;
      } else if (variant.available) {
        availabilityText.innerHTML = `
          <svg width="15" height="15" aria-hidden="true">
            <circle cx="7.5" cy="7.5" r="7.5" fill="rgb(62,214,96, 0.3)"/>
            <circle cx="7.5" cy="7.5" r="5" stroke="rgb(255, 255, 255)" stroke-width="1" fill="rgb(62,214,96)"/>
          </svg>
          ${window.variantStrings.inStock} <span class="info-icon"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path d="M1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8Z"
            stroke="#111111" stroke-width="1.6"/>
      <path d="M8 8V12" stroke="#111111" stroke-width="1.8"/>
      <path
          d="M9.25 5.25C9.25 5.94036 8.69036 6.5 8 6.5C7.30964 6.5 6.75 5.94036 6.75 5.25C6.75 4.55964 7.30964 4 8 4C8.69036 4 9.25 4.55964 9.25 5.25Z"
          fill="#111111"/>
    </svg></span>`;
      } else {
        availabilityText.innerHTML = `
          <svg width="15" height="15" aria-hidden="true">
            <circle cx="7.5" cy="7.5" r="7.5" fill="rgb(200,200,200, 0.3)"/>
            <circle cx="7.5" cy="7.5" r="5" stroke="rgb(255, 255, 255)" stroke-width="1" fill="rgb(200,200,200)"/>
          </svg>
          ${window.variantStrings.outOfStock}`;
      }
    }
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    this.updateMainImage();
    this.updateVariantThumbnail();
    this.resetImageSlider();

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach(mediaGallery => mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true));

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateMainImage() {
  const mainImageElement = document.querySelector('.main-product__media-gallery .swiper-slide img'); 

  if (mainImageElement && this.currentVariant.featured_media && this.currentVariant.featured_media.preview_image) {
    const imageUrl = this.currentVariant.featured_media.preview_image.src;
    const imageAlt = this.currentVariant.featured_media.alt || 'Product Image';

    mainImageElement.src = imageUrl.startsWith('http') ? imageUrl : `https:${imageUrl}`;
    mainImageElement.alt = imageAlt;
  }
}

   updateVariantThumbnail() {
    const firstThumbnail = document.querySelector('.main-product__media-thumbnails .swiper-slide img'); 
    if (firstThumbnail && this.currentVariant.featured_media) {
      firstThumbnail.src = this.currentVariant.featured_media.preview_image.src;
    }
  }

  updateStackedGallery() {
    const gallery = document.querySelector('[data-product-gallery-stacked]');
    const changeEvent = new Event('change');

    if (gallery) {
      gallery.dispatchEvent(changeEvent);
    }
  }

    resetImageSlider() {
    const swiperContainer = document.querySelector('.main-product__media-gallery');
    if (swiperContainer && swiperContainer.swiper) {
      swiperContainer.swiper.slideTo(0);
    }
  }

  createThumbnailElement(media) {
    const thumbnailElement = document.createElement('div');
    thumbnailElement.classList.add('main-product__media-thumbnail', 'swiper-slide');
    thumbnailElement.innerHTML = `
      <img src="${media.preview_image.src}" alt="${media.alt}">`;
    return thumbnailElement;
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const destination2 = document.getElementById(`price2-${this.dataset.section}`);
          const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const source2 = html.getElementById(`price2-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;
        if (source2 && destination2) destination2.innerHTML = source2.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);
        const price2 = document.getElementById(`price2-${this.dataset.section}`);
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }
        if (price) price.classList.remove('visibility-hidden');
        if (price2) price2.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);

        const gallerySource = html.querySelector("[data-product-gallery-stacked]");
        const galleryDestination = document.querySelector("[data-product-gallery-stacked]");
        if (galleryDestination && gallerySource) {
          galleryDestination.innerHTML = gallerySource.innerHTML
          this.updateStackedGallery();
        }
      });
  }
  updateLineItemProperties(productForm) {
    if (!this.currentVariant) return;
    const variant = this.currentVariant;
    let propertyInput = productForm.querySelector(`input[name="properties[${window.variantStrings.preOrder}]"]`);
    const pickupAvailability = document.querySelector('pickup-availability');
    const variantPreorders = JSON.parse(pickupAvailability.dataset.variantPreorders || '{}');
    const preorderText = variantPreorders[variant.id];

    if (variant.inventory_policy === 'continue' && variant.inventory_quantity <= 0 && variant.available) {
      if (!propertyInput) {
        propertyInput = document.createElement('input');
        propertyInput.type = 'hidden';
        propertyInput.name = `properties[${window.variantStrings.preOrder}]`;
        productForm.appendChild(propertyInput);
      }
      propertyInput.value = preorderText || window.variantStrings.preOrder;
    } else {
      if (propertyInput) {
        propertyInput.remove();
      }
    }
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;
  
    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      if (this.currentVariant && this.currentVariant.inventory_policy === 'continue' && this.currentVariant.inventory_quantity <= 0) {
        addButtonText.textContent = window.variantStrings.preOrder;
      } else {
        addButtonText.textContent = window.variantStrings.addToCart;
      }
      this.updateLineItemProperties(productForm);
    }
  
    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('.main-product__accordion-content') && this.classList.contains('complementary-products')) {
            this.remove();
          } else {
            const accordion = this.querySelector(".main-product__accordions");
            if (accordion) {
              const button = accordion.querySelector('.main-product__accordion-button');
              const content = accordion.querySelector(".main-product__accordion-content");

              button?.classList.add("accordion-active");

              if (content && content instanceof HTMLElement) {
                content.style.maxHeight = content.scrollHeight + "px";
              }
            }
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);


document.addEventListener("click", function(e){
  const accordion = e.target.closest(".course-accordion");

  if(accordion){
    let panel = accordion.nextElementSibling;
    let coursePanel = document.getElementsByClassName("accordion__panel");
    let courseAccordion = document.getElementsByClassName("course-accordion");
    let courseAccordionActive = document.getElementsByClassName("course-accordion accordion-active");

    if (panel.style.maxHeight){
      panel.style.maxHeight = null;
      accordion.classList.remove("accordion-active");
    } else {
      for (let iii = 0; iii < courseAccordionActive.length; iii++) {
        courseAccordionActive[iii].classList.remove("accordion-active");
      }
      for (let iiii = 0; iiii < coursePanel.length; iiii++) {
        accordion.classList.remove("accordion-active");
        coursePanel[iiii].style.maxHeight = null;
      }
      panel.style.maxHeight = panel.scrollHeight + "px";
      accordion.classList.add("accordion-active");
    }
    closeSubAccordion()
  }
});
let closeButtons = document.querySelectorAll('.facets-overlay, .accordion-close, .facets__elements-close');

if (closeButtons) {
  closeButtons.forEach((overlay) => {
    overlay.addEventListener('click', function () {
      closeAccordion();
    })
  })
}


// window.addEventListener('scroll', function() {
//   if (window.screen.width >= 768) {
//     closeAccordion();
//   }
// });
document.querySelectorAll('.facets__accordion').forEach((element) => {
  element.addEventListener('click', function() {
    if (window.screen.width < 768) {
      document.body.classList.add('overflow-hidden');
    }
  })
})

let facetDropdowns = document.querySelector('.facets__custom-dropdown--sorting .course-accordion-facets');

if (facetDropdowns) {
  facetDropdowns.addEventListener('click', function () {
    if (window.screen.width < 768) {
      document.body.classList.add('overflow-hidden');
    }
  })
}


window.addEventListener('resize', function() {
  if (window.screen.width >= 768) {
    closeAccordion();
    document.body.classList.remove('overflow-hidden');
  }
});

const closeAccordion = () => {
  let accordion = document.querySelector(".facets__accordion.accordion-active")
  if (accordion) {
    let panel = accordion.nextElementSibling;
    panel.style.maxHeight = null;
    accordion.classList.remove("accordion-active");
    document.body.classList.remove('overflow-hidden');

    closeSubAccordion()
  }

}
let facetsClose = document.querySelector('.facets__custom-dropdown--sorting .facets__sort-close');

if (facetsClose) {
  document.querySelector('.facets__custom-dropdown--sorting .facets__sort-close').addEventListener('click', function () {
    closeSubAccordion()
  })
}

const closeSubAccordion = () => {
  let subAccordion = document.querySelector('.course-accordion-facets.accordion-active');
  if (subAccordion) {
    subAccordion.classList.remove('accordion-active');
    let subAccordionPanel = subAccordion.nextElementSibling;
    subAccordionPanel.style.maxHeight = null;
    subAccordion.classList.remove("accordion-active");
    document.body.classList.remove('overflow-hidden');
  }
}

document.addEventListener("click", function(e){
  const target = e.target.closest('.facets__custom-checkbox input')

  if(target){
    closeSubAccordion();
  }
});

window.addEventListener('resize', function(event) {

  if (document.getElementsByClassName("accordion-active").length > 0) {
    let courseAccordionActive = document.querySelector(".accordion-active");

    let panelResize = courseAccordionActive.nextElementSibling;
    panelResize.style.maxHeight = panelResize.scrollHeight + "px";
  }

}, true);

document.addEventListener("click", function(e){
  const accordion = e.target.closest(".course-accordion-facets");
  if(accordion){
    let panel = accordion.nextElementSibling;
    let coursePanel = document.getElementsByClassName("accordion__panel-facets");
    let courseAccordion = document.getElementsByClassName("course-accordion-facets");
    let courseAccordionActive = document.getElementsByClassName("course-accordion-facets accordion-active");

    if (panel.style.maxHeight){
      panel.style.maxHeight = null;
      accordion.classList.remove("accordion-active");
    } else {
      for (let iii = 0; iii < courseAccordionActive.length; iii++) {
        courseAccordionActive[iii].classList.remove("accordion-active");
      }
      for (let iiii = 0; iiii < coursePanel.length; iiii++) {
        accordion.classList.remove("accordion-active");
        coursePanel[iiii].style.maxHeight = null;
      }
      panel.style.maxHeight = panel.scrollHeight + "px";
      accordion.classList.add("accordion-active");

      if (document.getElementsByClassName("accordion-active").length > 0) {
        let courseAccordionActive = document.querySelector(".accordion-active");

        let panelResize = courseAccordionActive.nextElementSibling;
        panelResize.style.maxHeight = (panelResize.scrollHeight + panel.scrollHeight) + "px";
      }
    }
  }
});

window.addEventListener('resize', function(event) {

  if (document.getElementsByClassName("accordion-active").length > 0) {
    let courseAccordionActive = document.querySelector(".accordion-active");

    let panelResize = courseAccordionActive.nextElementSibling;
    panelResize.style.maxHeight = panelResize.scrollHeight + "px";
  }

}, true);


class ProductsDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#ProductDrawer-overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    let productElement = document.querySelectorAll('.shop-this-look__product-info');
    let productMobileElement = document.querySelectorAll('.shop-this-look__product-info-mobile');
    productElement.forEach((element) => {
      element.setAttribute('role', 'button');
      element.setAttribute('aria-haspopup', 'dialog');
      element.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(element)
      });
      element.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(element);
        }
      });
    });
    productMobileElement.forEach((element) => {
      element.setAttribute('role', 'button');
      element.setAttribute('aria-haspopup', 'dialog');
      element.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(element)
      });
      element.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(element);
        }
      });
    });
    let closeDrawer = document.querySelector('.shop-this-look__drawer-close');

    closeDrawer.setAttribute('role', 'button');
    closeDrawer.setAttribute('aria-haspopup', 'dialog');
    closeDrawer.addEventListener('click', (event) => {
        event.preventDefault();
        this.close()
      });
    closeDrawer.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.close();
        }
      });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});
    let showProduct = triggeredBy.getAttribute('data-to-show-id');
    let productList = document.querySelectorAll('.shop-this-look__product-drawer-item')
    productList.forEach((product) => {
      let productShowId = product.getAttribute(`data-show-id`);
      if (productShowId === showProduct) {
        product.style.display = 'flex';
      }
      else {
        product.style.display = 'none';
      }
    })

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('ProductDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
        this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('product-drawer', ProductsDrawer);

class CollectionItems extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CollectionItems-overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    let productElement = document.querySelectorAll('.collection-items-drawer__call');
    productElement.forEach((element) => {
      element.setAttribute('role', 'button');
      element.setAttribute('aria-haspopup', 'dialog');
      element.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(element)
      });
      element.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(element);
        }
      });
    });

    let closeDrawer = document.querySelector('.collection-items-drawer__drawer-close');

    closeDrawer.setAttribute('role', 'button');
    closeDrawer.setAttribute('aria-haspopup', 'dialog');
    closeDrawer.addEventListener('click', (event) => {
      event.preventDefault();
      this.close()
    });
    closeDrawer.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.close();
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CollectionItems');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
        this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('collection-items', CollectionItems);

const menuItem = document.getElementsByClassName('facets__elements-links-title');

for (let item = 0; item < menuItem.length; item++) {
  menuItem[item].addEventListener('click', function () {
    if (window.screen.width < 992) {
      this.classList.toggle('facets__elements-links-title-active');
      let panel = this.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }
    }
  });
}

let searchToggle = document.getElementById('custom__search-call');
let searchBar = document.getElementById('custom__search-bar');
let results = document.querySelector('.custom__search-recommended-wrapper');
const openSearch = () => {
  if (window.screen.width < 768) {
    document.body.classList.add('overflow-hidden');
  }
  searchBar.classList.add('custom__search-bar--active');
  document.querySelector('.custom__search-recommended').style.display = 'block';
  document.querySelector('.custom__search-recommended-results-wrapper').style.display = 'none';
  setTimeout(function(){
    results.classList.add("custom__search-recommended-wrapper--active");
    document.querySelector('.custom__search-recommended-wrapper--active').style.maxHeight = document.querySelector('.custom__search-recommended').offsetHeight + 'px';
  }, 500);
}

const closeSearch = () => {
  searchBar.classList.remove('custom__search-bar--active');
  results.classList.remove("custom__search-recommended-wrapper--active");
  results.style.maxHeight = '0';
  document.body.classList.remove('overflow-hidden');
}

searchToggle.addEventListener('click', function() {
  if (searchBar.classList.contains('custom__search-bar--active')){
    closeSearch();
  }
  else {
    openSearch();
  }
})

document.querySelector('.modal-overlay').addEventListener('click', closeSearch);
document.querySelector('.custom__search-close').addEventListener('click', closeSearch);
document.addEventListener('keydown', evt => {
  if (evt.key === 'Escape') {
    closeSearch();
  }
});


// DRAWER MENU ADDRESSES

class addresses extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#addAddresses-overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }



  setHeaderCartIconAccessibility() {
    let productElement = document.querySelectorAll('.addAddresses__call');
    productElement.forEach((element) => {
      element.setAttribute('role', 'button');
      element.setAttribute('aria-haspopup', 'dialog');
      element.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(element)
      });

    element.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(element);
        }
      });
    });

    let closeDrawer = document.querySelectorAll('.addAddresses__drawer-close');

    closeDrawer.forEach((element) => {
      element.setAttribute('role', 'button');
      element.setAttribute('aria-haspopup', 'dialog');
      element.addEventListener('click', (event) => {
        event.preventDefault();
        this.close()
      });
      element.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.close();
        }
      });
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('addresses');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

 close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
        this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('drawer-menu-add', addresses);


// DRAWER MENU EDITRESSES

class editaresses extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#addAddresses-overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }



  setHeaderCartIconAccessibility() {
    let productElement = document.querySelectorAll('.editAddresses__call');
    productElement.forEach((element) => {
      element.setAttribute('role', 'button');
      element.setAttribute('aria-haspopup', 'dialog');
      element.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(element)
      });

    element.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(element);
        }
      });
    });

    let closeDrawer = document.querySelectorAll('.addAddresses__drawer-close');

    closeDrawer.forEach((element) => {
      element.setAttribute('role', 'button');
      element.setAttribute('aria-haspopup', 'dialog');
      element.addEventListener('click', (event) => {
        event.preventDefault();
        this.close()
      });
      element.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.close();
        }
      });
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('addresses');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

 close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
        this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('drawer-menu-edit', editaresses);


class ExpandText extends HTMLElement {
  constructor() {
    super();

    this.descMinHeight = 134;
    this.text = this.querySelector(".main-product__description");
    this.button = this.querySelector("button");

    if (!this.text || !this.button) {
      return;
    }

    if (this.text.scrollHeight > this.descMinHeight) {
      this.classList.add('is-expandable');
    } else {
      this.classList.remove('is-expandable');
    }

    this.button.addEventListener("click", this.onClick.bind(this))
  }

  onClick(e) {
    e.preventDefault();

    const isExpanded = this.getAttribute("aria-expanded");

    if (isExpanded === "true") {
      this.setAttribute("aria-expanded", "false");
      e.currentTarget.querySelector("span").textContent = "Show more"
    } else {
      this.setAttribute("aria-expanded", "true");
      e.currentTarget.querySelector("span").textContent = "Show less"
    }
  }
}
customElements.define('expand-text', ExpandText);

 // EDITS ADDRESSES FORM

 let editAddressButtons = document.querySelectorAll(".editAddresses__call");

 if (editAddressButtons) {
   editAddressButtons.forEach((button) => {
     let currentID = button.getAttribute('data-address-id');
     let editDrawerForms = document.querySelectorAll(".collection-items-drawer");
     button.addEventListener('click', function () {
       if (editDrawerForms) {
         editDrawerForms.forEach((form) => {
           if (currentID == form.getAttribute('data-address-id')){
             form.style.display = "flex";
           }
           else {
             form.style.display = "none";
           }
         });
       };
     });
   });
 };

// COOKIE

  function getBannerEl() {
    return document.getElementById('cookies-banner');
  }

  function hideBanner(res) {
    getBannerEl().style.display = 'none';
  }

  function showBanner() {
   getBannerEl().style.display = 'block';
  }

  function handleAccept(e) {
    window.Shopify.customerPrivacy.setTrackingConsent(true, hideBanner);

    document.addEventListener('trackingConsentAccepted',function() {
      console.log('trackingConsentAccepted event fired');
    });
  }

  function handleDecline() {
    window.Shopify.customerPrivacy.setTrackingConsent(false,hideBanner);
  }

  function initCookieBanner() {
    const userCanBeTracked = window.Shopify.customerPrivacy.userCanBeTracked();
    const userTrackingConsent = window.Shopify.customerPrivacy.getTrackingConsent();

    if(!userCanBeTracked && userTrackingConsent === 'no_interaction') {
      showBanner();
    }
  }

  window.Shopify.loadFeatures([
    {
      name: 'consent-tracking-api',
      version: '0.1',
    }
  ],
  function(error) {
    if (error) {
      throw error;
    }

    initCookieBanner();
  });

let geolocationCall = document.querySelectorAll('.geolocation__call');
let geolocationWindow = document.getElementById('geolocation-dropdown');
let geolocationClose = document.querySelector('.geolocation__close');

if (typeof(geolocationCall) != 'undefined' && geolocationCall != null) {

  geolocationCall.forEach((call) => {
      call.addEventListener('click', function () {
    document.getElementById('geolocation-dropdown').style.display = 'flex';
    
  })
  })
  

}

if (geolocationClose) {
  geolocationClose.addEventListener('click', function () {
    geolocationWindow.style.display = 'none';
  })
}

function reveal() {
  let reveals = document.querySelectorAll(".fade-up, .fade");

  if (reveals) {
    for (let i = 0; i < reveals.length; i++) {
      let windowHeight = window.innerHeight;
      let elementTop = reveals[i].getBoundingClientRect().top;
      let elementVisible = 100;
        if (window.screen.width <= 768) {
          elementVisible = 50;
        }
      window.addEventListener('resize', function() {
        if (window.screen.width <= 768) {
          elementVisible = 50;
        }
        else {
          elementVisible = 100;
        }
      })

      if (elementTop < windowHeight - elementVisible) {
        reveals[i].classList.add("animation-visible");
      }
    }
  }
}

let preloaderExists = document.getElementById('preloader');

window.addEventListener("scroll", reveal);
window.addEventListener('DOMContentLoaded', function () {
  if (preloaderExists) {
    setTimeout(reveal, 2000);
  }
  else {
    reveal();
  }
})

let clearSearch = document.getElementById('clearSearch');
if (clearSearch) {
  clearSearch.addEventListener('click', function() {
    let searchBarTemplate = document.getElementById('Search-In-Template')
    searchBarTemplate.value = '';
    searchBarTemplate.focus();
  })
}
document.addEventListener('DOMContentLoaded', function() {
    var allLinks = document.getElementsByTagName('a');
    for (var i = 0; i < allLinks.length; i++) {
        var link = allLinks[i];
        if (link.hostname !== window.location.hostname ){
            link.target = '_blank';
            link.rel = 'noopener noreferrer';
        }
    }
    var footerLinks = document.querySelector('footer').getElementsByTagName('a');
    for (var j = 0; j < footerLinks.length; j++) {
        var footerLink = footerLinks[j];
        if (footerLink.hostname !== window.location.hostname && !footerLink.classList.contains('no-icon')) {
            footerLink.innerHTML += '<span class="btn-icon"><svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 3L3 11" stroke="#FEFEFE" style="stroke:#FEFEFE;stroke:color(display-p3 0.9961 0.9961 0.9961);stroke-opacity:1;" stroke-width="1.4"/><path d="M11 11V3H3" stroke="#FEFEFE" style="stroke:#FEFEFE;stroke:color(display-p3 0.9961 0.9961 0.9961);stroke-opacity:1;" stroke-width="1.4"/></svg><svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 3L3 11" stroke="#FEFEFE" style="stroke:#FEFEFE;stroke:color(display-p3 0.9961 0.9961 0.9961);stroke-opacity:1;" stroke-width="1.4"/><path d="M11 11V3H3" stroke="#FEFEFE" style="stroke:#FEFEFE;stroke:color(display-p3 0.9961 0.9961 0.9961);stroke-opacity:1;" stroke-width="1.4"/></svg></span>';
        }
    }
    var headerLinks = document.querySelector('header').getElementsByTagName('a');
    for (var u = 0; u < headerLinks.length; u++) {
        var headerLink = headerLinks[u];
        if (headerLink.hostname !== window.location.hostname && !headerLink.classList.contains('no-icon')) {
            headerLink.classList.add('megamenu-link-style')
            headerLink.innerHTML += '<span class="btn-icon"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13 3L3 13" stroke="#FEFEFE" style="stroke:#FEFEFE;stroke:color(display-p3 0.9961 0.9961 0.9961);stroke-opacity:1;" stroke-width="1.8"/><path d="M13 13V3H3" stroke="#FEFEFE" style="stroke:#FEFEFE;stroke:color(display-p3 0.9961 0.9961 0.9961);stroke-opacity:1;" stroke-width="1.8"/></svg></span>';
        }
    }
});